module.exports = "/images/history_blue.svg?139f39dcd427e9cac1b494d559ff20e2";